<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <div v-if="exibir">
      <vs-card class="showMobile">
        <vs-pagination
          :max="screenWidth < 650 ? 5 : 9"
          v-if="qtdPaginas > 1"
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination>
      </vs-card>

      <vs-card v-if="!qtdPaginas" class="flex justify-center p-4">
        <h4 class="mt-2">Nenhum Beneficiário Encontrado</h4>
      </vs-card>

      <div v-for="item in paginatedItems" :key="item.id">
        <div class="relative">
          <vs-card>
            <div class="vx-row">
              <div class="vx-col flex w-full justify-between">
                <div class="flex w-full justify-between mr-2 ml-2">
                  <div class="vx-col flex gap-1 mt-2 mb-4">
                    <vs-chip class="divIdProposta rounded" color="#078fcf">{{
                      item.id_prospect
                    }}</vs-chip>
                    <vs-chip
                      :color="getStatusColor(item.situacao)"
                      class="divIdProposta rounded"
                    >
                      {{ getStatusString(item.situacao) }}
                    </vs-chip>
                    <router-link
                      target="_blank"
                      :to="`/DetalheAssociado/${item.id_prospect}`"
                    >
                      <feather-icon
                        icon="ExternalLinkIcon"
                        svgClasses="h-4 w-4"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:flex lg:justify-between ml-2">
                <div class="gap-3 mb-4 lg:w-full mr-2">
                  <div class="divSubTitle">
                    {{ item.nome }}
                  </div>
                  <div class="divInfo">{{ item.tipo }}</div>
                  <div class="divInfo">
                    {{ item.email }}
                  </div>
                  <div v-if="item.telefone" class="divInfo">
                    {{ item.telefone }}
                  </div>
                  <div>
                    <a
                      target="_blank"
                      :href="`https://wa.me/55${item.celular
                        .replace('(', '')
                        .replace(')', '')
                        .replace(' ', '')
                        .replace('-', '')}`"
                      v-if="item.celular"
                      class="divInfo cursor-pointer"
                    >
                      {{ item.celular }}
                      <vs-icon
                        color="success"
                        icon-pack="fa"
                        icon="fa-whatsapp"
                      >
                      </vs-icon>
                    </a>
                  </div>
                  <div>
                    <a
                      target="_blank"
                      :href="`https://wa.me/55${item.celularAdicional
                        .replace('(', '')
                        .replace(')', '')
                        .replace(' ', '')
                        .replace('-', '')}`"
                      v-if="item.celularAdicional"
                      class="divInfo cursor-pointer"
                    >
                      {{ item.celularAdicional }}
                      <vs-icon
                        color="success"
                        icon-pack="fa"
                        icon="fa-whatsapp"
                      >
                      </vs-icon>
                    </a>
                  </div>
                </div>

                <div class="gap-3 mb-4 lg:w-full mr-2">
                  <div v-if="item.dataAtivacao" class="sm:block flex gap-2">
                    <p class="divTitle">DATA DE ATIVAÇÃO</p>
                    <div class="divInfo">
                      {{ formataData(item.dataAtivacao) }}
                    </div>
                  </div>
                  <div v-else class="lg:block flex gap-2">
                    <p class="divTitle">DATA DE CRIAÇÃO</p>
                    <div class="divInfo">
                      {{ formataData(item.createdAt) }}
                    </div>
                  </div>
                </div>

                <div class="gap-2 mb-4 lg:block flex lg:w-full mr-2">
                  <p class="divTitle">DIVISÃO/REGIONAL</p>
                  <div class="divInfo">
                    <div>{{ item.nome_divisao }}</div>
                    <div>{{ item.regional }}</div>
                  </div>
                </div>

                <div class="gap-2 mb-4 lg:block flex lg:w-full mr-2">
                  <p class="divTitle">CIDADE/UF</p>
                  <div class="divInfo">
                    {{ item.cidade }} / {{ item.estado }}
                  </div>
                </div>

                <div class="dropdownAcoes mr-2">
                  <vs-dropdown vs-trigger-click class="flex cursor-pointer">
                    <div
                      class="rounded-full cursor-pointer"
                      style="background: #078fcf"
                    >
                      <vs-icon
                        round
                        class="m-1"
                        size="medium"
                        color="white"
                        icon="more_horiz"
                      ></vs-icon>
                    </div>

                    <vs-dropdown-menu style="width: 250px">
                      <vs-dropdown-item
                        :to="`/EditarAssociado/${item.id_prospect}`"
                        v-if="$can($actionsDefault.Escrita, subjectPermission)"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="success"
                            icon-pack="feather"
                            icon="icon-edit"
                          >
                          </vs-icon>
                          <span>Editar Beneficiário</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        divider
                        class="pt-2"
                        :to="`/DetalheAssociado/${item.id_prospect}`"
                        v-if="
                          $can($actionsDefault.Escrita, subjectPermission) ||
                          $can($actionsDefault.Leitura, subjectPermission)
                        "
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="primary"
                            icon-pack="feather"
                            icon="icon-search"
                          >
                          </vs-icon>
                          <span>Ver detalhes do Beneficiário</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        divider
                        class="pt-2"
                        target="_blank"
                        @click="opemModalMobile(item)"
                        v-if="$can('Enviar Código', subjectPermission)"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="dark"
                            icon-pack="feather"
                            icon="icon-smartphone"
                          >
                          </vs-icon>
                          <span>Enviar Código de Confirmação</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        divider
                        class="pt-2"
                        target="_blank"
                        @click="resetarSenhaAssociado(item)"
                        v-if="permissaoresetarSenhaAssociado"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="warning"
                            icon-pack="feather"
                            icon="icon-rotate-ccw"
                          >
                          </vs-icon>
                          <span>Resetar Senha Beneficiário</span>
                        </div>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
            </div>
          </vs-card>
        </div>
      </div>

      <vs-card>
        <vs-pagination
          :max="screenWidth < 650 ? 5 : 9"
          v-if="qtdPaginas"
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination
      ></vs-card>
      <!------------ END Proposta ------------>

      <!------------ START INFORMAÇÕES DO Proposta ------------>
      <vs-popup
        v-if="modalSelecionado != {}"
        class="holamundo"
        :title="'Enviar Código'"
        :active.sync="popupActive"
        @close="closePop"
      >
        <div v-if="!modalSelecionado.celular">
          <vs-alert
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            Este Beneficiário não possui número de celular vinculado, edite os
            dados e tente novamente
          </vs-alert>
          <router-link :to="`/EditarAssociado/${modalSelecionado.id_prospect}`">
            <vs-button
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-edit"
              class="d-inline"
              @click="closePop"
              >Editar dados</vs-button
            >
          </router-link>
        </div>
        <div v-else>
          <vs-alert
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <p v-if="modalSelecionado.codigoVerificacao">
              O Código de verificação atual é
              <b>{{ modalSelecionado.codigoVerificacao }}</b>
            </p>
            <p v-else>Beneficiário ainda não possui Código de Verificação</p>
          </vs-alert>

          <vs-alert
            color="dark"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            Um novo código de verificação será enviado para
            {{ modalSelecionado.celular }}
          </vs-alert>

          <vs-button
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-send"
            class="d-inline"
            @click="enviarCodigo(modalSelecionado.id_prospect)"
            >Enviar Novo Código</vs-button
          >
        </div>
      </vs-popup>
    </div>
    <div v-else>
      <vs-alert
        color="warning"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        É Necessário fazer um filtro para exibir os Beneficiários, (clique em
        buscar)
      </vs-alert>
    </div>
    <!------------ END INFORMAÇÕES DO Proposta ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import service from '../../services';
import moment from 'moment';
import jwt from 'jsonwebtoken';
import notify from '../../utils/notify.js';
import { decryptData } from '../../services/decryptData';

export default {
  props: ['filtro', 'realizaFiltro', 'vistoria', 'subjectPermission', 'limpar'],
  watch: {
    realizaFiltro: async function (newValue) {
      if (newValue) {
        await this.buscaDados();
        this.paginaAtual = 1;
        this.$emit('filtroOk', true);
      }
    },
    limpar(value) {
      if (value) this.limparFiltro();
      this.$emit('limpouFiltro');
    },
  },
  data() {
    return {
      chave: 0,
      isAdmin: false,
      idEmpresa: null,
      dadosSideBar: {},
      controllerGeral: 'Proposta',
      formSideBar: 'Proposta',
      entidade: 'Proposta',
      titleSideBar: 'Adicionar Proposta',
      popupActive: false,
      modalSelecionado: {},
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 10,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      isMounted: false,
      addNewDataSidebar: false,
      exibir: false,
      regionais: [],
      regionaisUsuarios: [],
      regionalDefault: [],
      usuarios_regionais: [],
      idRegionais: [],
      regionaisUsuario: [],
      screenWidth: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    permissaoresetarSenhaAssociado() {
      return this.$can('Resetar Senha Associado', 'Associados');
    },
    paginatedItems() {
      const start = (this.paginaAtual - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.itens.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.itens.length / this.itemsPerPage);
    },
  },
  methods: {
    verificaAdmin() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == 'Super User') this.isAdmin = true;
      }
      const decoded = jwt.decode(token);
      this.id_usuario = decoded.id_usuario;
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        // this.idEmpresa = this.decoded.id_empresa;
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    novaProposta() {
      this.$router.push('novaProposta/Interno');
    },
    somaValorTotalMes(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal == true) total = total + element.valorFinal;
      });
      return total;
    },
    calculaQtddeDiasEnviada(status, date) {
      var a = moment();
      var horas = a.diff(date, 'hours');
      return horas + 'h aguardando';
    },
    getStatusColorHoras(status, date) {
      var a = moment();
      var horas = a.diff(date, 'hours');
      if (horas < 10) return 'success';
      if (horas >= 10 && horas <= 24) return 'warning';
      if (horas > 24) return 'danger';
    },

    somaValorTotal(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal != true) total = total + element.valorFinal;
      });
      return total;
    },
    closePop() {
      this.popupActive = false;
    },
    closeSideBar() {
      this.addNewDataSidebar = false;
      this.chave++;
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },

    enviarCodigo(id) {
      this.$vs.loading();
      var objSend = {};
      objSend.idProspect = id;
      service
        .post('Associado', 'ReenviarCodigo', objSend)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Novo Código reenviado com sucesso',
            color: 'success',
          });
          this.$vs.loading.close();
          this.popupActive = false;
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            if (element[campoPK] == this.decoded.id_regional) {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            }
          });
        });
    },
    async buscaDados() {
      this.filtred = true;
      this.selected = [];

      const objSend = this.filtro ? { ...this.filtro } : {};

      objSend.regional =
        this.filtro && this.filtro.regional
          ? this.filtro.regional.map((item) => item.id)
          : this.idRegionais;

      objSend.idEmpresa = this.idEmpresa;
      try {
        this.$vs.loading();
        const { data } = await service.post(
          'Associado',
          'listarAssociadosFiltro',
          objSend,
        );
        this.exibir = true;
        this.itens = [];
        this.qtdTotal = data.qtd;
        this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

        this.qtdPaginas = Math.ceil(this.qtdPaginas);

        if (this.qtdTotal > 0) {
          data.associados.forEach((element) => {
            this.itens.push(element);
          });
        }
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível listar',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    buscaRegionais() {
      this.$vs.loading();
      service
        .getAll(
          'Usuario',
          {},
          `list/idEmpresa=${this.idEmpresa}?idUsuario=${this.id_usuario}`,
        )
        .then((res) => {
          this.$vs.loading.close();
          res.data.forEach((element) => {
            if (element.idUsuario == this.id_usuario) {
              if (element.usuarios_regionais.length > 0) {
                this.usuarios_regionais = element.usuarios_regionais;
                this.usuarios_regionais.forEach((elementSel) => {
                  this.regionaisUsuario.push({
                    id: elementSel.id_regional,
                    label: elementSel.nome,
                  });
                });
                this.regionais = this.regionaisUsuario.concat(
                  this.regionalDefault,
                );
                this.idRegionais = this.regionais.map((item) => item.id);
              } else {
                var usuarios_regionais = element.Usuarios_Regional;
                this.regionais.push({
                  id: usuarios_regionais.idRegional,
                  label: usuarios_regionais.nome,
                });
                this.idRegionais = this.regionais.map((item) => item.id);
              }
            }
          });
          this.buscaDados();
        });
    },
    openSideBar(dados) {
      dados.idProposta == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    opemModalMobile(item) {
      this.popupActive = true;
      this.modalSelecionado = item;
    },
    concluido() {
      this.chave++;
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == 'ATIVO') return 'success';
      if (data == null) return 'warning';
      if (data == 'INADIMPLENTE') return 'danger';
      if (data == 'Pendente') return 'bg-blue';
      if (data == 'Finalizada') return 'dark';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Prospect';
      return data;
    },
    resetarSenhaAssociado(item) {
      const { id_prospect, id_empresa } = item;
      notify.notifyCustonColor(
        this.$vs,

        'Resetando senha do Beneficiário, aguarde...',
      );
      service
        .put('Associado', 'resetar-senha', {
          idProspect: id_prospect,
          idEmpresa: id_empresa,
        })
        .then(() => {
          notify.notifySuccess(
            this.$vs,
            'Sucesso! A senha do Beneficiário foi resetada para o CPF/CNPJ dele com ponto e traço.',
          );
        })
        .catch(() => {
          notify.notifyFail(
            this.$vs,
            'Falha ao resetar a senha do Beneficiário, por favor tente novamente.',
          );
        });
    },

    setItemsPerPage(value) {
      this.itemsPerPage = value;
      this.paginaAtual = 1;
    },
    limparFiltro() {
      this.exibir = false;
      this.itens = [];
    },
  },
  created() {},
  mounted() {
    this.getDecoded();
    this.verificaAdmin();
    this.isMounted = true;
    this.screenWidth = window.innerWidth;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style scoped src="../../assets/css/listCard.css"></style>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}

.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}

.divSubTitle {
  text-transform: uppercase;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
}
</style>

<!------------ END STYLE ------------>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
